export default __webpack_public_path__ + "static/media/653de415789a352663e8e044dbed3313.8383c8a0.png";